import {Team} from "../../api/Model";
import {Box, BoxProps, Tooltip, Typography, TypographyProps} from "@mui/material";
import React from "react";

export default function TeamComponent({teamPath, slotProps}: {
    teamPath: Team[];
    slotProps?: {
        wrapper?: BoxProps;
        content?: TypographyProps;
    };
}) {

    return (
        <Box width="20em" {...slotProps?.wrapper}>
            {teamPath.length > 0 ? (
                <Tooltip title={teamPath.map(team => team.name).join(' > ')}>
                    <Typography variant="body2" sx={{
                        textOverflow: 'ellipsis',
                        overflow: 'hidden',
                        textWrap: 'nowrap',
                        width: '100%'
                    }} {...slotProps?.content}>{teamPath[teamPath.length - 1].name}</Typography>
                </Tooltip>
            ) : null}
        </Box>
    );
}